<template>
  <v-dialog v-model="dialog" persistent max-width="600px" content-class="configuration-dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on }">
      <v-btn :disabled="disabled" color="primary" v-on="on" class="mr-2">
        <v-icon left>edit</v-icon>{{$t('Button.Edit')}}
      </v-btn>
    </template>
    <v-flex>
      <v-card flat dark>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Edit Configuration</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-flex>
    <v-flex style="overflow: auto;">
      <v-card flat>
        <v-card-text pa-0>
          <component :is="form" ref="configurationComponent" @validate="onValidate" @setValidated="setValidated" @submit="onSubmit" @block="onBlock" />
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex>
      <v-card style="border-top: 1px solid #dddddd;">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!isValidated || isBlocked" color="success" @click="submit()">
            <v-icon left>done</v-icon>{{$t('Button.Save')}}
          </v-btn>
          <v-btn color="secondary" outline @click="close()">{{$t('Button.Close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-dialog>
</template>

<script>
  import ErrorMessages from '../Helpers/ErrorMessages'

  export default {
    props: {
      configuration: Object,
      form: Function,
      disabled: Boolean,
    },
    data: () => ({
      dialog: false,
      isValidated: false,
      isBlocked: false,
      isSaving: false,
    }),
    computed: {
      currentService() {
        return this.$store.getters['serviceconfigurations/currentService']
      },
    },
    watch: {
      dialog(value) {
        if (value) {
          console.log({ config: this.configuration })
          this.$refs.configurationComponent.assignObject(this.configuration)
        }
      },
    },
    methods: {
      close() {
        this.reset()
        this.dialog = false
      },
      submit() {
        this.$refs.configurationComponent.submit()
      },
      setValidated(value) {
        this.isValidated = value
      },
      async  onValidate(validationModel) {
        try {
          let response = await this.$store.dispatch('serviceconfigurations/validateConfiguration', {
            service: this.currentService,
            payload: validationModel,
          })

          this.$refs.configurationComponent.setValidateResponse(response.data)
        } catch (error) {
          console.log(error)
          this.$refs.configurationComponent.invalidate(ErrorMessages.fatalErrorMessageLabel, ErrorMessages
            .fatalErrorMessageLong)
        }
      },
      onBlock(result) {
        this.isBlocked = result
      },
      async onSubmit(configuration) {
        try {
          await this.$store.dispatch('serviceconfigurations/updateConfiguration', {
            configuration,
            service: this.currentService,
          })

          this.$emit('fetchConfigurations')
          this.close()
        } catch (error) {
          console.log(error)
          this.isSaving = false
          this.$refs.configurationComponent.invalidate(ErrorMessages.fatalErrorMessageLabel, ErrorMessages
            .fatalErrorMessageLong)
        }
      },
      reset() {
        setTimeout(function() {
          this.isSaving = false
          this.isValidated = false
          if(this.$refs.configurationComponent) {
            this.$refs.configurationComponent.resetForm()
          }          
        }.bind(this), 500)
      },
      setStateSaving(value) {
        this.isSaving = value
        this.isBlocked = value
      },
    },
   /* mounted () {
       // this.$refs.configurationComponent.assignObject(this.configuration)
    },*/
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>
<style>
  .configuration-dialog {
    display: flex;
    flex-direction: column;
  }
</style>